var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"messages p-20",attrs:{"id":"messages-container"}},[_vm._l((_vm.items),function(item,i){return [(!item.name)?_c('system-message',{key:i,attrs:{"item":item}}):_c('chat-message',{key:i,attrs:{"item":item}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }